export const channelPayoutBasisOptions = [
  { value: 'net_premium', label: 'Net Premium' },
  { value: 'gross_premium', label: 'Gross Premium' },
  { value: 'od_premium', label: 'OD Premium' },
  { value: 'tp_premium', label: 'TP Premium' },
  { value: 'broker_commission', label: 'Broker Commission (Commission on Commission)' },
];

export const BROKER_COMMISSION_HINT =
  "% applies to the broker's earned commission on the policy, not premium.";

/** OD/TP split is meaningless when the base is a single scalar (broker_commission). */
export function basisHidesOdTp(basis: string): boolean {
  return basis === 'broker_commission';
}
